import type { SourceType } from '../../../shared/api/types'
import { SOURCE_LABELS } from './AddResultForm'

type QuoteBrief = {
  supplierName: string
  price: number | null
  currency: string | null
  sourceType: SourceType
}

/**
 * Диалог подтверждения удаления квоты со страницы позиции. Вынесен из
 * QuotesTable, чтобы таблица укладывалась в лимит 500 строк; разметка и тексты
 * — те же, что были инлайн.
 */
export function DeleteQuoteDialog({
  quote,
  saving,
  onCancel,
  onConfirm,
}: {
  quote: QuoteBrief
  saving: boolean
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={() => !saving && onCancel()}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-sm font-semibold text-gray-900">Удалить квоту?</h3>
        <p className="text-xs text-gray-500 mt-1.5">
          Квота «{quote.supplierName}» —{' '}
          {quote.price == null ? 'без цены' : `${quote.price} ${quote.currency ?? ''}`} (
          {SOURCE_LABELS[quote.sourceType]}). Действие необратимо.
        </p>
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onCancel}
            disabled={saving}
            className="px-3 py-1.5 text-xs text-gray-600 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50"
          >
            Отмена
          </button>
          <button
            onClick={onConfirm}
            disabled={saving}
            className="px-3 py-1.5 text-xs text-white rounded-lg bg-red-600 hover:bg-red-700 disabled:opacity-50"
          >
            {saving ? 'Удаление…' : 'Да, удалить'}
          </button>
        </div>
      </div>
    </div>
  )
}
